import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
const $Input = (tag, _1, _2) => ({tag, _1, _2});
const RefLabel = x => x;
const RefUpdate = value0 => value1 => $Input("RefUpdate", value0, value1);
const Action = value0 => $Input("Action", value0);
const ordRefLabel = Data$dOrd.ordString;
const newtypeRefLabel = {Coercible0: () => {}};
const functorInput = {
  map: f => m => {
    if (m.tag === "RefUpdate") { return $Input("RefUpdate", m._1, m._2); }
    if (m.tag === "Action") { return $Input("Action", f(m._1)); }
    $runtime.fail();
  }
};
const eqRefLabel = Data$dEq.eqString;
export {$Input, Action, RefLabel, RefUpdate, eqRefLabel, functorInput, newtypeRefLabel, ordRefLabel};
